import { render, staticRenderFns } from "./position.vue?vue&type=template&id=5b09ee7c&scoped=true";
import script from "./position.vue?vue&type=script&lang=jsx";
export * from "./position.vue?vue&type=script&lang=jsx";
import style0 from "./position.vue?vue&type=style&index=0&id=5b09ee7c&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "5b09ee7c", null);
export default component.exports;